import { Link } from 'react-router-dom';
import { platforms } from '@/mocks/platforms';
import PlatformCard from '@/components/base/PlatformCard';

export default function FeaturedPlatforms() {
  const topPlatforms = platforms
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">
            精选推荐
          </span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-800">
            热门欧美无码正版平台
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            基于内容质量、用户体验、性价比等多个维度，为您精选最值得订阅的欧美无码平台
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {topPlatforms.map((platform) => (
            <PlatformCard key={platform.id} {...platform} />
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/category/hd"
            className="inline-flex items-center gap-2 px-6 py-3 border border-primary-500/30 text-primary-500 rounded-lg hover:bg-primary-500/10 transition-all duration-300 cursor-pointer text-sm font-medium"
          >
            查看全部平台
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}